import { modulesNameSynonymMapper } from "../../services/constants";
import { t } from "@i18n";

export const recentAccessConstant = {
  project: "PROJECT",
  estimate: "ESTIMATE",
  schedule: "SCHEDULE",
  file: "FILE",
  transmittal: "TRANSMITTAL",
  task: "TASK",
  space: "SPACE",
  review: "REVIEW",
  inspection: "INSPECTION",
  progressUpdate: "PROGRESS_UPDATES",
  changeOrder: "CHANGE_ORDER",
  mailbox: "MAILBOX",
  clash: "CLASH",
  contract: "CONTRACT",
  issue: "ISSUE",
  bills: "BILLS",
};

export function recentModuleName({ module, portal }: any) {
  const data: any = {
    INSPECTION: {
      title: t("Inspection"),
      icon: "inspectionForm",
      mobileIcon: "InspectionForm",
    },
    BILLS: {
      title: t("Bills"),
      icon: "bills",
      mobileIcon: "Bills",
    },
    PROGRESS_UPDATES: {
      title: t("Progress Update"),
      icon: "ProgressUpdates",
      mobileIcon: "ProgressUpdates",
    },
    CHANGE_ORDER: {
      title: t("Change Order"),
      icon: "changeOrder",
    },
    ESTIMATE: {
      title: t("Estimate"),
      icon: "EstimateIcon",
    },
    SCHEDULE: {
      title: t("Schedule"),
      icon: "schedules",
    },
    FILE: {
      title: t("File"),
      icon: "FilesIcon",
    },
    TRANSMITTAL: {
      title: t("Transmittal"),
      icon: "Transmittals",
    },
    TASK: {
      title: t("Task"),
      icon: "TasksIcon",
    },
    SPACE: {
      title: portal ? (portal.includes("dpmsportal") ? `${modulesNameSynonymMapper.space}` : t("Space")) : t("Space"),
      icon: "SpacesIcon",
      mobileIcon: "SpaceIcon",
    },
    REVIEW: {
      title: t("Review"),
      icon: "Review",
    },
    ISSUE: {
      title: t("Issue"),
      icon: "IssuesIcon",
    },
    MAILBOX: {
      title: t("Mailbox"),
      icon: "Mailbox",
    },
    CLASH: {
      title: t("Clash"),
      icon: "ClashIcon",
    },
    CONTRACT: {
      title: t("Contract"),
      icon: "Contracts",
      mobileIcon: "Contracts",
    },
  };
  return data[module];
}
